import { render, staticRenderFns } from "./DisclaimerQuestion.vue?vue&type=template&id=2e32c258&scoped=true&"
import script from "./DisclaimerQuestion.vue?vue&type=script&lang=js&"
export * from "./DisclaimerQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerQuestion.vue?vue&type=style&index=0&id=2e32c258&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e32c258",
  null
  
)

export default component.exports